import {call, put, all, takeEvery} from 'redux-saga/effects';
import {passwordResetService, passwordEnterService, passwordResetServiceSMS, verifyAttemptResetPasswordByPhoneNumberService, resetPasswordForPhoneUsers} from './services';

import {
  PASSWORD_RESET_REQUEST,
  PASSWORD_RESET_REQUEST_SUCCESS,
  PASSWORD_RESET_REQUEST_ERROR,
  ENTER_PASSWORD,
  ENTER_PASSWORD_SUCCESS,
  ENTER_PASSWORD_ERROR,
  VERIFY_PASSWORD_ATTEMPT_CHANGE,
  VERIFY_PASSWORD_ATTEMPT_CHANGE_SUCCESS,
  VERIFY_PASSWORD_ATTEMPT_CHANGE_ERROR,
  RESEND_CODE_PHONE_SUCCESS,
  RESEND_CODE_PHONE_ERROR,
  RESEND_CODE_PHONE
} from './constants';

import StoreService from '../../utils/StoreService';
import { setNotificationError, setNotificationSuccess } from '../Notifications/actions';
import intl from '../../intl';
import generalMessages from '../generalMessages';
import { AxiosError, AxiosResponse } from 'axios';
import {login} from '../Login/actions'
import { push } from 'connected-react-router';



function* passwordResetFlow(action: any) {

  const {data} = action;
  const {email, phone} = data;

  try {
    yield email ? call(passwordResetService, data) :  call(passwordResetServiceSMS, data);
    yield put({type: PASSWORD_RESET_REQUEST_SUCCESS, data});

    StoreService.dispatch(setNotificationSuccess(phone ? intl.formatMessage(generalMessages.ResetPasswordPhoneNotif) : intl.formatMessage(generalMessages.ResetPasswordMsg)))
    
  } catch (error) {
    if(error) {
      const {response} = error as AxiosError;
      const {data}  = response as AxiosResponse; 
      yield put({type: PASSWORD_RESET_REQUEST_ERROR, error})

      StoreService.dispatch(setNotificationError(data.error === 'phone' ? intl.formatMessage(generalMessages.PhoneNumberNotRight) : intl.formatMessage(generalMessages.EmailNotRight)))
    }
  }
}

function* passwordEnterFlow(action: any) {

  const {data} = action;
  const {email, password, phone}: {email: string, password: string, phone: string} = data;

  try {

    const response: AxiosResponse = email ? yield call(passwordEnterService, data) : yield call(resetPasswordForPhoneUsers, data); 

    yield put({type: ENTER_PASSWORD_SUCCESS, response});
    const username: string = email ? email : phone;
    
    yield StoreService.dispatch(login({username, password}));
    //yield put(push(`?modal=true&LoginPage=true`));
    StoreService.dispatch(setNotificationSuccess(intl.formatMessage(generalMessages.ResetSuccess)))

  } catch (error) {
    
    const {response} = error as AxiosError;
    StoreService.dispatch(setNotificationError(response && response.status === 422 ? intl.formatMessage(generalMessages.TokenResetPasswordExpired) : intl.formatMessage(generalMessages.SomethingNotRight)))
    yield put({type: ENTER_PASSWORD_ERROR, error})
  }
}

// VerifyPhoneNumber
function* verifyResetPasswordAttemptFlow(action: any) {
  
  const {data} = action;
  const {code} = data;

  try {
    const response: AxiosResponse = yield call(verifyAttemptResetPasswordByPhoneNumberService, data);
    
    yield put({type: VERIFY_PASSWORD_ATTEMPT_CHANGE_SUCCESS, response});

    yield put(push(`/?modal=true&NewPasswordPagePhone=true&code=${code}`));

  } catch (error) {
    if(error) {
      const {response} = error as AxiosError;

      StoreService.dispatch(setNotificationError(response && response.status === 422 ? 
        intl.formatMessage(generalMessages.VerificationCodeDoesNotExist) : 
        response && response.status === 429 ? intl.formatMessage(generalMessages.ToMuchTimeTriedResetPassword) : intl.formatMessage(generalMessages.SomethingNotRight) 
        ));

    }
    yield put({type: VERIFY_PASSWORD_ATTEMPT_CHANGE_ERROR, error});
  }
}

// Resend code phone
function* resendCode(action: any) {
  const {phone} = action;
  try {
    const response: AxiosResponse = yield call(passwordResetServiceSMS, {phone: phone});
    yield put({type: RESEND_CODE_PHONE_SUCCESS, response});
  } catch (error) {
    yield put({type: RESEND_CODE_PHONE_ERROR, error});
  }
}

export default function* forgotPasswordSaga() {
    yield all([
      takeEvery(PASSWORD_RESET_REQUEST, passwordResetFlow),
      takeEvery(ENTER_PASSWORD, passwordEnterFlow),
      takeEvery(VERIFY_PASSWORD_ATTEMPT_CHANGE, verifyResetPasswordAttemptFlow),
      takeEvery(RESEND_CODE_PHONE, resendCode),
    ])
}